<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      baseForm: {
        stateOptions: [],
        orgIdOptions: [],
        form: [
          {
            label: '客户编码',
            value: 'customerCode',
            type: 'input',
            disabled: true,
          },
          {
            label: '客户全称',
            value: 'companyName',
            type: 'input',
          },
          {
            label: '联系人',
            value: 'lineName',
            type: 'input',
          },
          {
            label: '联系手机',
            value: 'linePhone',
            type: 'input',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
          },
          {
            label: '公司地址',
            value: 'address',
            type: 'input',
          },
          {
            label: '客户状态',
            value: 'state',
            type: 'select',
            hide: !this.$route.query.id,
          },
        ],
        rules: {
          companyName: [ // 客户全称
            { required: true, message: '请输入客户全称', trigger: 'blur' },
          ],
          lineName: [ // 联系人
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          linePhone: [ // 联系手机
            { required: true, message: '请输入联系手机', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          orgId: [ // 归属部门
            { required: true, message: '请选择归属部门', trigger: 'blur' },
          ],
          address: [ // 公司地址
            { required: true, message: '请输入公司地址', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'SYS_STATE_DESC',
      });
      this.baseForm.stateOptions = enumsList[0];
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      if (data.state !== undefined || data.state !== null) {
        data.state = String(data.state);
      }
      this.$nextTick(() => {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: !this.$route.query.id,
          names: ['state', 'customerCode'],
        });
      });
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
